import { render } from "./AcceptIcon.vue?vue&type=template&id=8400d6f0"
import script from "./AcceptIcon.vue?vue&type=script&lang=js"
export * from "./AcceptIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__